import { getLanguageCode, isKnownLocaleTag } from "@pandas/core-ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import i18next from "../../i18n";
import { useStore } from "../../store";

export const Route = createFileRoute("/$locale")({
	beforeLoad: async ({ params, location }) => {
		if (!isKnownLocaleTag(params.locale)) return;

		const canonical = getLanguageCode(params.locale);
		if (canonical !== params.locale) {
			const pathParts = location.pathname.split("/");
			pathParts[1] = canonical;
			throw redirect({ to: pathParts.join("/"), search: location.search, replace: true });
		}

		// The URL is the source of truth for locale: keep i18next + the Zustand store in sync.
		if (i18next.language !== canonical) {
			await i18next.changeLanguage(canonical);
		}
		if (useStore.getState().language !== canonical) {
			useStore.getState().setLanguage(canonical);
		}
	},
	component: () => <Outlet />,
});
